/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createTheme } from "@mui/material";

export const techwiseThemeDark = createTheme({
    breakpoints: {
        // TODO possible breaking change.
        // @ts-ignore
        values: {
            xs: 0,
            sm: 1200, // techwise staff wanted mobile view on tablets
            xl: 1536,
        },
    },
    palette: {
        mode: "dark",
        primary: {
            main: process.env.REACT_APP_PRIMARY_COLOR_DARK as string,
        },
        secondary: {
            main: "#888888",
        },
    },
    components: {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    // Create a greyish backdrop to emphasize the modal.
                    backgroundColor: "rgba(50,50,50,0.5)",
                },
            },
        },
    },
});

export const techwiseThemeLight = createTheme({
    breakpoints: {
        // TODO possible breaking change.
        // @ts-ignore
        values: {
            xs: 0,
            sm: 1200, // techwise staff wanted mobile view on tablets
            xl: 1536,
        },
    },
    palette: {
        mode: "light",
        secondary: {
            main: "#888888",
        },
        primary: {
            main: process.env.REACT_APP_PRIMARY_COLOR_LIGHT as string,
        },
    },
});
